import { Grid } from "@mui/material";
import { McParameterDetailResponseDto } from "src/api/references/referenceServicesDtos";
import ByzCard from "src/components/core-components/ByzCard";
import { ByzMuiDateTimePicker } from "src/components/core-components/mui/inputs/ByzMuiDateTimePicker";
import ByzMuiTextField from "src/components/core-components/mui/inputs/ByzMuiTextField";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import ByzMcParameterDetailSelect from "src/components/shared-components/ByzMcParameterDetailSelect";

interface PainCardProps {
  t: (key: string) => string;
  cardData: any;
  selectedMCPs: Record<string, any>;
  handleMCPChange: (key: string, value: McParameterDetailResponseDto) => void;
  handleChange: (key: string, value: any) => void;
  getMCPParameterDetails: (id: number) => any;
  mcpCacheLoaded: boolean;
  typedFormData: Record<string, any>;
}

const PainTypeCard: React.FC<PainCardProps> = ({
  t,
  cardData,
  selectedMCPs,
  handleMCPChange,
  handleChange,
  getMCPParameterDetails,
  mcpCacheLoaded,
  typedFormData,
}) => {
  return (
    <ByzCard sx={{ mt: 2, p: 2 }}>
      {/* DAILY_LIFE_EFFECTS */}
      <Grid container spacing={2} alignItems="center" mt={1}>
        <Grid item xs={4}>
          <ByzMuiTypography>
            {t(
              "pain-assessment-scale.pain-assessment.right.daily-life-effects"
            )}
          </ByzMuiTypography>
        </Grid>
        <Grid item xs={8}>
          <ByzMcParameterDetailSelect
            title={t("select")}
            mcpId={cardData.mcpConfig.DAILY_LIFE_EFFECTS.mcpId}
            multiple={false}
            handleChange={(val) => {
              if (val && !Array.isArray(val)) {
                handleMCPChange(
                  "DAILY_LIFE_EFFECTS",
                  val as McParameterDetailResponseDto
                );
              }
            }}
            value={selectedMCPs.DAILY_LIFE_EFFECTS}
            sx={{ width: "100%" }}
            cachedData={getMCPParameterDetails(
              cardData.mcpConfig.DAILY_LIFE_EFFECTS.mcpId
            )}
            cacheLoaded={mcpCacheLoaded}
          />
        </Grid>
      </Grid>
      {/* BEGIN_TIME */}
      <Grid container spacing={2} alignItems="center" mt={1}>
        <Grid item xs={4}>
          <ByzMuiTypography>
            {t("pain-assessment-scale.pain-assessment.right.start-time")}
          </ByzMuiTypography>
        </Grid>
        <Grid item xs={8}>
          <ByzMuiDateTimePicker
            value={cardData.BEGIN_TIME || ""}
            onChange={(e) => handleChange("BEGIN_TIME", e)}
          />
        </Grid>
      </Grid>
      {/* PAIN_EFFECT */}
      <Grid container spacing={2} alignItems="center" mt={1}>
        <Grid item xs={4}>
          <ByzMuiTypography>
            {t("pain-assessment-scale.pain-assessment.right.pain-effect")}
          </ByzMuiTypography>
        </Grid>
        <Grid item xs={8}>
          <ByzMcParameterDetailSelect
            title={t("select")}
            mcpId={cardData.mcpConfig.PAIN_EFFECT.mcpId}
            multiple={false}
            handleChange={(val) => {
              if (val && !Array.isArray(val)) {
                handleMCPChange(
                  "PAIN_EFFECT",
                  val as McParameterDetailResponseDto
                );
              }
            }}
            value={selectedMCPs.PAIN_EFFECT}
            sx={{ width: "100%" }}
            cachedData={getMCPParameterDetails(
              cardData.mcpConfig.PAIN_EFFECT.mcpId
            )}
            cacheLoaded={mcpCacheLoaded}
          />
        </Grid>
      </Grid>
      {/* PAIN_REDUCTION_TARGET */}
      <Grid container spacing={2} alignItems="center" mt={1}>
        <Grid item xs={4}>
          <ByzMuiTypography>
            {t(
              "pain-assessment-scale.pain-assessment.right.pain-reduction-target"
            )}
          </ByzMuiTypography>
        </Grid>
        <Grid item xs={8}>
          <ByzMcParameterDetailSelect
            title={t("select")}
            mcpId={cardData.mcpConfig.PAIN_REDUCTION_TARGET.mcpId}
            multiple={false}
            handleChange={(val) => {
              if (val && !Array.isArray(val)) {
                handleMCPChange(
                  "PAIN_REDUCTION_TARGET",
                  val as McParameterDetailResponseDto
                );
              }
            }}
            value={selectedMCPs.PAIN_REDUCTION_TARGET}
            sx={{ width: "100%" }}
            cachedData={getMCPParameterDetails(
              cardData.mcpConfig.PAIN_REDUCTION_TARGET.mcpId
            )}
            cacheLoaded={mcpCacheLoaded}
          />
        </Grid>
      </Grid>

      {/* TARGET_EXPLANATION */}
      <Grid container spacing={2} alignItems="center" mt={1}>
        <Grid item xs={4}>
          <ByzMuiTypography>
            {t("pain-assessment-scale.explanation")}
          </ByzMuiTypography>
        </Grid>
        <Grid item xs={8}>
          <ByzMuiTextField
            fullWidth
            value={typedFormData.TARGET_EXPLANATION || ""}
            onChange={(e) => handleChange("TARGET_EXPLANATION", e.target.value)}
          />
        </Grid>
      </Grid>
    </ByzCard>
  );
};

export default PainTypeCard;
